//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /**
     * Single selection search filter control. When selected, this component will set the value of its parent search-filter to be the provided value. This
     * is intended to be used alongside other search-filter-single-selectors where each will update the value of their shared parent search-filter. The icon
     * for the selector can be set using the background css property for the search-filter-single-selector-icon class.
     * @param {string} label - label displayed as control
     * @param {string} value - value which this component outputs
     */
  curalate.component('searchFilterSingleSelector', {
    bindings: {
      label: '@',
      value: '<',
      noIcon: '<',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    controllerAs: 'searchFilterSingleSelectorCtrl',
    template: require('@legacy-components/filters/search-filter-single-selector.html'),
    controller: ['$scope',
      function($scope) {
        const self = this;
        $scope.model = {
          label: self.label,
          selected: false,
        };

        const calculateIfSelectedFromOptions = function(options) {
          if ((!options || options.length === 0) && (self.value === null || self.value === undefined)) {
                        // If no filter options are set and the current filter's value is null, implicitly select this filter
            return true;
          }

          return _(options).contains(self.value);
        };

        const select = function() {
          $scope.model.selected = true;
          if (self.value === null || self.value === undefined) {
                        // Remove the filter and value.
            self.searchFilter.clearValues();
          } else {
            self.searchFilter.setValue(self.value);
          }
        };

        const unselect = function() {
          $scope.model.selected = false;
        };

        const onChange = function(newState) {
          const isSelected = $scope.model.selected;
          const isNewSelected = calculateIfSelectedFromOptions(newState);
          if (isSelected !== isNewSelected) {
            if (!isSelected && isNewSelected) {
              select();
            } else if (isSelected && !isNewSelected) {
              unselect();
            }
          }
        };

        self.$onInit = function() {
          self.searchFilter.registerFilterOptionAlias(self.value, self.label);

          $scope.model.lockedKey = self.searchFilter.isKeyLocked();
          const isSelected = calculateIfSelectedFromOptions(self.searchFilter.getValue());
          if (isSelected) {
            select();
          }

          self.searchFilter.getFilterValueStream().subscribe(onChange);
        };

        $scope.select = function() {
          if ($scope.model.lockedKey) {
            return;
          }
          select();
        };
      },
    ],
  });
})();
